// Navigation
$('#menu-toggle').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger');
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $hamburger.addClass('is-active');
    } else {
        $menu.removeClass('menu-active');
        $hamburger.removeClass('is-active');
    }
});

$(document).ready(function () {

// Change Recaptcha error message
    if ($('.message.error').length) {
        changeErrMsg();
    }

// Change Recaptcha error message
    if ($('#Form_registerForm_BackURL_login_error').length) {
        changeErrMsg2();
    }

    if ($('.error-block.resend-verification-email').length) {
        resenVerificationEmail();
    }
});

function resenVerificationEmail() {
    let targetArea = $('.error-block.resend-verification-email .element-container .content-element-btn-container');
    let target = targetArea.children('a');

    if (target.text() === 'Resend verification email') {
        target.on('click', function () {
            $.ajax({
                url: '/MapData/resendVerificationEmail',
                method: 'POST',
                dataType: 'json',
                success: function (data) {
                    let results = JSON.parse(JSON.stringify(data));

                    if (results === 'success') {
                        targetArea.parent().append('<p class="message good">You have successfully been registered. ' +
                            'Please check your email for the verification link. In case you don\'t see it, ' +
                            'please check your spam and junk folders. You won\'t be able to see the map without ' +
                            'verifying your email first.</p>');
                    } else {
                        targetArea.parent().append('<p class="message bad">Something went wrong. Please try logging' +
                            'in first. If you are already logged in or the error persists, please contact us ' +
                            'at <a href="mailto:help@logicstudio.nz">help@logicstudio.nz</a></p>');
                    }
                }
            });
        });
    }
}

function changeErrMsg() {
    let targetParent = $('.nocaptcha')
    let target;

    if (targetParent.children('.message.error').length) {
        let target = targetParent.children('.message.error');
        target.text('Verification failed. Please try to verify again.');
    }
}

function changeErrMsg2() {
    let target = $('#Form_registerForm_BackURL_login_error');

    console.log(target.val());
    console.log(target.text());

    if (target.text() === 'Please answer the captcha, if you do not see the captcha please enable JavaScript') {
        target.text('Verification failed. Please try to verify again.');
    }
    // target.text('Verification failed. Please try to verify again.');

    // if (targetParent.children('.message.error').length) {
    //     let target = targetParent.children('.message.error');
    //     target.text('Verification failed. Please try to verify again.');
    // }
}
